import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { StaffEmployeesService } from "lib-klab-sdks";
import { StaffEmployeesPort } from "../../../app/ports/employment/staff-employees.port";
import {
  EmployeeStatus,
  StaffEmployee,
  StaffEmployeeUpsertRequest,
} from "../../../domain/models/employment/employee.model";
import {
  mapStaffEmployee,
  mapStaffEmployeeRequest,
} from "../../mappers/employment/employee.mapper";

@Injectable({ providedIn: "root" })
export class StaffEmployeesPortAdapter implements StaffEmployeesPort {
  constructor(private readonly api: StaffEmployeesService) {}

  list(
    companyId?: number,
    status?: EmployeeStatus,
  ): Observable<StaffEmployee[]> {
    return this.api
      .list(companyId, status)
      .pipe(map((items) => items.map(mapStaffEmployee)));
  }

  getById(employeeId: number): Observable<StaffEmployee> {
    return this.api.getById(employeeId).pipe(map(mapStaffEmployee));
  }

  create(request: StaffEmployeeUpsertRequest): Observable<StaffEmployee> {
    return this.api
      .create(mapStaffEmployeeRequest(request))
      .pipe(map(mapStaffEmployee));
  }

  update(
    employeeId: number,
    request: StaffEmployeeUpsertRequest,
  ): Observable<StaffEmployee> {
    return this.api
      .update(employeeId, mapStaffEmployeeRequest(request))
      .pipe(map(mapStaffEmployee));
  }

  deactivate(employeeId: number): Observable<void> {
    return this.api.deactivate(employeeId);
  }

  terminate(employeeId: number): Observable<StaffEmployee> {
    return this.api.terminate(employeeId).pipe(map(mapStaffEmployee));
  }
}
